import { downloadDocument } from "../../features";
import {addLoadingState, removeLoadingState} from "../helpers";

// This file contains JavaScript code for the Mortgage overview page of the Stater EConsumer Portal. It includes a function to initialize the page and log a message to the console when the page is viewed.
export function initHypotheekPage() {
    checkForDialogs();

    // Add this block to handle downloadRepaymentSchedule buttons
    document.querySelectorAll('[id^="downloadRepaymentSchedule-"]').forEach(el => {
        el.addEventListener('click', downloadRepaymentSchedule);
    });
    
    const cesKey = document.querySelector("[data-loan-overview-ces-key]")?.dataset?.loanOverviewCesKey;
    window.customerEffortScore.trigger(cesKey);
}


function downloadRepaymentSchedule(event) {
    event.preventDefault();
    
    const href = event.currentTarget.getAttribute('data-href');
    addLoadingState(event);
    
    downloadDocument(href)
        .then(() => {
            const cesKey = document.querySelector("[data-repayment-schedule-ces-key]")?.dataset?.repaymentScheduleCesKey;
            window.customerEffortScore.trigger(cesKey);            
        }).catch(error => {
            console.error('Error downloading repayment schedule:', error);
            // after Stefano has introduced a toaster component this alert can be replaced with a toaster, which can probably accept a contentful key and retrieves it's own content
            alert('Het downloaden van het aflossingsschema is mislukt. Probeer het later opnieuw.');
        }).finally(() => {
            removeLoadingState(event);
        });
}

function checkForDialogs() {
    const intermediaryPromise = fetch('/Hypotheek/ShowConfirmIntermediaryPermissionDialog')
        .then(r => r.text());

    const advisorPromise = fetch('/AdvisorAssignment/ShowAdvisorAssignmentDialog')
        .then(r => r.text());

    const transferQuestionPromise = fetch('/Hypotheek/ShowTransferQuestion')
        .then(r => r.text());

    Promise.all([intermediaryPromise, advisorPromise, transferQuestionPromise])
        .then(([intermediaryUrl, advisorUrl, transferQuestionUrl]) => {
            if (intermediaryUrl) {
                window.dialog.open({ url: intermediaryUrl });
                return;
            }
            if (advisorUrl) {
                window.dialog.open({ url: advisorUrl });
                return;
            }
            if (transferQuestionUrl) {
                window.dialog.open({ url: transferQuestionUrl });
                return;
            }
        })
        .catch(err => console.error('Error checking dialogs:', err));
}